(function () {
  'use strict';

  var STORE_ORIGINS = ['https://exlibris.store', 'https://www.exlibris.store'];
  var CONFIGURATOR_ORIGIN = 'https://exlibris-configurator-production.up.railway.app';
  var CONFIGURATOR_PATHS = ['/', '/foto', '/foto/'];
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var STORAGE_KEY = 'exlibris_attribution_v1';
  var TTL = 30 * 60 * 1000;
  var decorated = new Map();
  var lastCapture = '';
  var expiryTimer;
  var loading = false;
  var loaderAttempts = 0;
  var entryCanCapture = false;
  var localizedProduct = null;

  try {
    var bridgeScript = document.currentScript;
    var renderedHandle = bridgeScript && bridgeScript.getAttribute('data-exlibris-product-handle');
    var renderedValue = bridgeScript && bridgeScript.getAttribute('data-exlibris-product-url');
    if (renderedHandle && /^[a-z0-9][a-z0-9-]*$/.test(renderedHandle) && renderedValue) {
      var renderedUrl = new URL(renderedValue);
      if (STORE_ORIGINS.indexOf(renderedUrl.origin) !== -1 && renderedUrl.origin === window.location.origin &&
          !renderedUrl.username && !renderedUrl.password && !renderedUrl.search && !renderedUrl.hash &&
          /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*$/.test(renderedUrl.pathname) &&
          renderedUrl.pathname.split('/').pop() === renderedHandle) {
        localizedProduct = { handle: renderedHandle, origin: renderedUrl.origin, path: renderedUrl.pathname };
      }
    }
  } catch (error) {}

  if (STORE_ORIGINS.indexOf(window.location.origin) === -1) return;
  if (window.__exlibrisAttributionBridgeV1) return;
  window.__exlibrisAttributionBridgeV1 = true;
  try {
    var navigation = window.performance.getEntriesByType('navigation')[0];
    entryCanCapture = !!navigation && navigation.type === 'navigate';
  } catch (error) {}

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }

  function cleanCampaign(source) {
    var result = {};
    KEYS.forEach(function (key) {
      var value = source[key];
      if (typeof value === 'string' && value && value.length <= 256 && !/[\u0000-\u001f\u007f]/.test(value)) result[key] = value;
    });
    return result;
  }

  function removeStored() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
    window.clearTimeout(expiryTimer);
  }

  function release(anchor) {
    var owned = decorated.get(anchor);
    if (!owned) return;
    try {
      var url = new URL(anchor.href);
      Object.keys(owned).forEach(function (key) {
        if (url.searchParams.get(key) === owned[key]) url.searchParams.delete(key);
      });
      anchor.href = url.href;
    } catch (error) {}
    decorated.delete(anchor);
  }

  function releaseAll() {
    Array.from(decorated.keys()).forEach(release);
  }

  function readStored() {
    try {
      var record = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      var now = Date.now();
      if (!record || record.version !== 1 || !Number.isSafeInteger(record.expiresAt) ||
          record.expiresAt <= now || record.expiresAt > now + TTL || !record.campaign || typeof record.campaign !== 'object') {
        removeStored();
        return null;
      }
      var campaign = cleanCampaign(record.campaign);
      if (!Object.keys(campaign).length) { removeStored(); return null; }
      return { version: 1, expiresAt: record.expiresAt, campaign: campaign };
    } catch (error) { removeStored(); return null; }
  }

  function armExpiry(record) {
    window.clearTimeout(expiryTimer);
    if (record) expiryTimer = window.setTimeout(function () {
      removeStored();
      releaseAll();
    }, Math.max(0, record.expiresAt - Date.now()));
  }

  function refresh() {
    releaseAll();
    if (!allowed()) { removeStored(); lastCapture = ''; return null; }
    var record = readStored();
    var page = new URL(window.location.href);
    var isReturn = page.hash.indexOf('#ec:') === 0 || page.searchParams.get('ec_attribution_return') === '1';
    var raw = {};
    KEYS.forEach(function (key) { if (page.searchParams.has(key)) raw[key] = page.searchParams.get(key); });
    if (entryCanCapture && !isReturn && Object.keys(raw).length) {
      var fingerprint = JSON.stringify(raw);
      if (fingerprint !== lastCapture) {
        var campaign = cleanCampaign(raw);
        if (!Object.keys(campaign).length) { removeStored(); record = null; }
        else if (!record || JSON.stringify(record.campaign) !== JSON.stringify(campaign)) {
          record = { version: 1, expiresAt: Date.now() + TTL, campaign: campaign };
          try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record)); }
          catch (error) { removeStored(); record = null; }
        }
        lastCapture = fingerprint;
      }
    }
    armExpiry(record);
    return record;
  }

  function eligible(anchor) {
    try {
      var url = new URL(anchor.href);
      if (url.origin !== CONFIGURATOR_ORIGIN || CONFIGURATOR_PATHS.indexOf(url.pathname) === -1 || url.username || url.password) return null;
      var product = url.searchParams.get('product');
      var returnValue = url.searchParams.get('return') || url.searchParams.get('return_url');
      if (!product || !/^[a-z0-9][a-z0-9-]*$/.test(product) || !returnValue) return null;
      var returnUrl = new URL(returnValue);
      var sameRenderedProduct = localizedProduct && product === localizedProduct.handle &&
        returnUrl.origin === localizedProduct.origin && returnUrl.pathname === localizedProduct.path;
      if (STORE_ORIGINS.indexOf(returnUrl.origin) === -1 || returnUrl.username || returnUrl.password ||
          (returnUrl.pathname !== '/products/' + product && !sameRenderedProduct)) return null;
      if (KEYS.some(function (key) { return url.searchParams.has(key) || returnUrl.searchParams.has(key); }) ||
          url.searchParams.has('ec_attribution') || url.searchParams.has('ec_attribution_expires')) return null;
      return url;
    } catch (error) { return null; }
  }

  function findAnchor(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      var item = path[i];
      if (item && typeof item.closest === 'function') {
        var anchor = item.closest('a[href]');
        if (anchor) return anchor;
      }
    }
    return null;
  }

  function prepareLink(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    var anchor = findAnchor(event);
    var record = refresh();
    if (!anchor || !record) return;
    var url = eligible(anchor);
    if (!url) return;
    var owned = {};
    KEYS.forEach(function (key) {
      if (record.campaign[key]) { owned[key] = record.campaign[key]; url.searchParams.set(key, owned[key]); }
    });
    owned.ec_attribution = '1';
    owned.ec_attribution_expires = String(record.expiresAt);
    url.searchParams.set('ec_attribution', owned.ec_attribution);
    url.searchParams.set('ec_attribution_expires', owned.ec_attribution_expires);
    anchor.href = url.href;
    decorated.set(anchor, owned);
  }

  function initialize() {
    if (window.Shopify && window.Shopify.customerPrivacy) { refresh(); return; }
    if (loading) return;
    if (loaderAttempts >= 20) { refresh(); return; }
    loaderAttempts++;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loading = true;
      var deadline = window.setTimeout(function () { loading = false; refresh(); }, 5000);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          window.clearTimeout(deadline);
          loading = false;
          refresh();
        });
      } catch (error) { window.clearTimeout(deadline); loading = false; refresh(); }
    } else window.setTimeout(initialize, 250);
  }

  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'keydown'].forEach(function (name) {
    document.addEventListener(name, prepareLink, true);
  });
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) entryCanCapture = false;
    initialize();
  });
  window.addEventListener('focus', refresh);
  initialize();
})();
